export default __webpack_public_path__ + "static/media/csc_06.8ed99f1e.png";